import React, { useEffect, useState } from "react";
import { Container, Form} from "react-bootstrap";
import "./TaskAssignMembers.scss";
import MemberSuggestionsInput from "./MemberSuggestionsInput";
import AssignedMemberPills from "./AssignedMemberPills";
import { getPermissionMembers, 
        filterAvailableMembers, 
        initializeOwnerMembers, 
        getIds, 
        displayName,
        getUpdatedFilterMembersName, 
        getGroupedUsers, 
        renderMemberSection } from './TaskAssignMemberHelper';
import PropTypes from "prop-types";

const TaskAssignMembersMultiOwner = ({
  assignedMembers,
  assignedOwner,
  filteredAssignedMembers,
  addMembersInForm,
  removeMembersInForm,
  isDisabled,
  permissionTaskMembers = [],
  ownerGroup = null,
  CanChangeApprover,
  CanChangeEditor,
  CanChangeViewer,
  CanChangeOwner,
}) => {

  const [membersList, setMembersList] = useState([]);
  const [ownerMembers, setOwnerMembers] = useState(() => initializeOwnerMembers(assignedOwner));
  const [editorMembers, setEditorMembers] = useState([]);
  const [viewerMembers, setViewerMembers] = useState([]);
  const [approverMembers, setApproverMembers] = useState([]);
  const [activeSuggestion, setActiveSuggestion] = useState(0);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [filteredOwnerSuggestions, setFilteredOwnerSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState({ owner: false, editor: false, viewer: false, approver: false });
  const [filteredMembersName, setFilteredMembersName] = useState([]);
  const [inputField, setInputField] = useState({ owner:"", editor: "", viewer: "", approver: "" });
  const [errorMessage, setErrorMessage] = useState({ owner:"", editor: "", viewer: "", approver: "" });
  const assignMemberOptions = ["Owner","Editor", "Viewer", "Approver"];

  useEffect(() => {
    if (ownerGroup?.GroupMembers) {
      ownerGroup.Members = ownerGroup.GroupMembers;
    }
  }, [ownerGroup]);
 
  useEffect(() => { 
    let editorArray = getAssignedMembers("editor");
    let viewerArray = getAssignedMembers("viewer");
    let approverArray = getAssignedMembers("approver");
    let removeConcatMembers = getUpdatedFilterMembersName([...editorArray, ...viewerArray, ...approverArray], filteredAssignedMembers);
    setMembersList([...assignedMembers]);
    setFilteredMembersName([...removeConcatMembers]);
    setFilteredSuggestions([...removeConcatMembers]);
    setEditorMembers([...editorArray]);
    setViewerMembers([...viewerArray]);
    setApproverMembers([...approverArray]);

    const assignedOwnerIds = getIds(assignedOwner);
    const currentOwnerIds = getIds(ownerMembers);
    
    if (JSON.stringify(assignedOwnerIds) !== JSON.stringify(currentOwnerIds)) {
      const updatedOwners = assignedOwnerIds
        .map(id => assignedMembers.find(m => m.Id === id))
        .filter(Boolean);
    
      setOwnerMembers(updatedOwners);
    
      const selectedOwnerNames = updatedOwners.map(m => m?.Name);
      const filtered = filteredAssignedMembers.filter(
        name => !selectedOwnerNames.includes(name)
      );
      setFilteredOwnerSuggestions(filtered);
    }
  }, [assignedMembers, filteredAssignedMembers]);

  const updateFilterMembersName = (permission, filterName) => {
    let newFilterNames = [];
    let resultFilterMembersName = [];

    if (permission === "editor") {
      newFilterNames = editorMembers.find(member => member.Name === filterName);
    } else if (permission === "viewer") {
      newFilterNames = viewerMembers.find(member => member.Name === filterName);
    } else if (permission === "approver") {
      newFilterNames = approverMembers.find(member => member.Name === filterName);
    } else if (permission === "owner") {
      newFilterNames = ownerMembers.find(member => member.Name === filterName);
    }

    if (newFilterNames) {
      resultFilterMembersName = [...filteredMembersName];
      resultFilterMembersName.push(filterName);
    } else {
      resultFilterMembersName = [...filteredMembersName.filter(name => filterName !== name)];
    }

    return resultFilterMembersName;
  };

  const getAssignedMembers = permission => {
    const newPermissionMember = getPermissionMembers(permission, permissionTaskMembers);
    return filterAvailableMembers(newPermissionMember, assignedMembers);
  };

  const assignMembers = (permission) => {
    switch (permission) {
      case "editor": return editorMembers;
      case "viewer": return viewerMembers;
      case "approver": return approverMembers;
      case "owner": return ownerMembers;
      default: return [];
    }
  };
  
  const updateMembers = (permission, newMembers) => {
    switch (permission) {
      case "editor": setEditorMembers(newMembers); break;
      case "viewer": setViewerMembers(newMembers); break;
      case "approver": setApproverMembers(newMembers); break;
      case "owner": setOwnerMembers(newMembers); break;
      default: break;
    }
  };
  
  const disablePill = (permission) => {
    if (isDisabled) return true;
  
    switch (permission) {
      case "editor": return !CanChangeEditor;
      case "viewer": return !CanChangeViewer;
      case "approver": return !CanChangeApprover;
      case "owner": return !CanChangeOwner;
      default: return true;
    }
  };  

  const showUserMembers = permission => (
    <AssignedMemberPills
      members={assignMembers(permission)}
      permission={permission}
      disablePill={disablePill(permission)}
      onRemove={user => deleteUserMembers(permission, user)}
      isDisabled={isDisabled}
    />
  );

  const deleteUserMembers = (permission, removedUser) => {
    if (permission === "owner" && ownerMembers.length <= 1) {
      return;
    }
    let updatedMembers = assignMembers(permission);
    let removedMember = updatedMembers.find(
      member => member.Id === removedUser.Id && member.IsGroup === removedUser.IsGroup
    );

    if (permission !== "owner") {
      const updatedFilter = updateFilterMembersName(permission, removedMember.Name);
      setFilteredMembersName([...updatedFilter]);
      setFilteredSuggestions([...updatedFilter]);
    }

    updatedMembers = updatedMembers.filter(
      member => !(member.Id === removedUser.Id && member.IsGroup === removedUser.IsGroup)
    );

    if (permission === "owner") {
      const remainingOwnerNames = updatedMembers.map(m => m.Name);
      const filtered = filteredAssignedMembers.filter(
        suggestion => !remainingOwnerNames.includes(suggestion)
      );
      setFilteredOwnerSuggestions(filtered);
    }

    removeMembersInForm(permission, removedUser.Id, removedUser.IsGroup);
    updateMembers(permission, updatedMembers);
  };

  const onChangeMemberInput = (e, permission) => {
    let currInput = e.currentTarget.value;
    let availableSuggestions = filteredMembersName.filter(
      suggestion => suggestion.toLowerCase().indexOf(currInput.toLowerCase()) > -1
    );
    if (currInput) {
      setShowSuggestions({ ...showSuggestions, [permission]: true });
    } else {
      setShowSuggestions({ ...showSuggestions, [permission]: false });
    }
    if(permission !== "owner"){
      setFilteredSuggestions(availableSuggestions);
    }
    else{
        const selectedOwnerNames = ownerMembers.map(m => m.Name);
        const filtered = filteredAssignedMembers
            .filter(
            suggestion =>
                suggestion.toLowerCase().includes(currInput.toLowerCase()) &&
                !selectedOwnerNames.includes(suggestion)
            );
        setFilteredOwnerSuggestions(filtered);
    }
    setErrorMessage({ ...errorMessage, [permission]: "" });
    setInputField({ ...inputField, [permission]: e.currentTarget.value });
  };

  const onKeyDownAddMembers = (e, permission) => {
    if (e.keyCode === 13) {
      setActiveSuggestion(0);
      setShowSuggestions({ ...showSuggestions, [permission]: false });
      setInputField({ ...inputField, [permission]: filteredSuggestions[activeSuggestion] });
    } else if (e.keyCode === 38) {
      if (activeSuggestion === 0) {
        return;
      }
      setActiveSuggestion(activeSuggestion - 1);
    } else if (e.keyCode === 40) {
      if (activeSuggestion - 1 === filteredSuggestions.length) {
        return;
      }
      setActiveSuggestion(activeSuggestion + 1);
    }
  };

  const onClickMemberSuggestion = (suggestion, permission) => {
    let updatedMembers = assignMembers(permission);
    // New members filter now by words due to inner text remove last space in names automatically
    let newMember = membersList.filter(
      member => member.Name.split(" ").join("") === suggestion.split(" ").join("")
    );

    const addId = newMember[0]?.Id;
    const checkEditorExists = editorMembers.some(member => member.Name === newMember[0]?.Name);
    const checkViewerExists = viewerMembers.some(member => member.Name === newMember[0]?.Name);
    const checkApproverExists = approverMembers.some(member => member.Name === newMember[0]?.Name);

    if ((checkEditorExists || checkViewerExists || checkApproverExists) && permission !== "owner") {
      setErrorMessage({
        ...errorMessage,
        [permission]: `${displayName(newMember[0])} already exists, please try a different member`
      });
    } else {
      if(newMember[0]?.IsGroup){
        addMembersInForm(permission, addId, true);
      }
      else{
        addMembersInForm(permission, addId, false);
      }
      updatedMembers = [...updatedMembers, ...newMember];
      updateMembers(permission, updatedMembers);
    }
    setActiveSuggestion(0);

    if(permission !== "owner"){
      setFilteredSuggestions([...updateFilterMembersName(permission, newMember[0]?.Name)]);
      setFilteredMembersName([...updateFilterMembersName(permission, newMember[0]?.Name)]);
    }
    else{
        const selectedOwnerNames = [...ownerMembers, ...newMember].map(m => m.Name);
        const filtered = filteredAssignedMembers.filter(
          suggestion => !selectedOwnerNames.includes(suggestion)
        );
        setFilteredOwnerSuggestions(filtered);
    }
    
    setShowSuggestions({ ...showSuggestions, [permission]: false });
    setInputField({ ...inputField, [permission]: "" });
  };

  const handleLostFocus = (permission, event) => {
    setShowSuggestions({ ...showSuggestions, [permission]: false });
    setInputField({ ...inputField, [permission]: "" });
    setFilteredSuggestions(filteredMembersName);
    event.preventDefault();
  };

  const handleOnFocus = (permission, event) => {
    setShowSuggestions({ ...showSuggestions, [permission]: true });
    setInputField({ ...inputField, [permission]: "" });
    event.preventDefault();
  };

  const UsersFromProjectAndDepartment = (option) => {
    const { membersFromProject, membersFromDepartment } = getGroupedUsers(
      option,
      filteredSuggestions,
      filteredOwnerSuggestions,
      membersList,
      ownerMembers
    );
  
    return (
      <>
        {renderMemberSection(
          membersFromProject,
          "Users from the Selected Project",
          option,
          membersList,
          onClickMemberSuggestion,
          onKeyDownAddMembers
        )}
        {renderMemberSection(
          membersFromDepartment,
          "Users from your Department",
          option,
          membersList,
          onClickMemberSuggestion,
          onKeyDownAddMembers
        )}
      </>
    );
  };

  return (
    <div>
      <Container className="form-custom-control assignMemberContainer mt-3">
        {assignMemberOptions.map(option => (
          <Form.Group key={option.toLowerCase()}>
            <Form.Label className={`loginInput`}>{option}</Form.Label>
            <MemberSuggestionsInput
              role={option.toLowerCase()}
              inputValue={inputField[option.toLowerCase()]}
              showSuggestions={showSuggestions[option.toLowerCase()]}
              disablePill={disablePill(option.toLowerCase())}
              errorMessage={errorMessage[option.toLowerCase()]}
              showUserMembers={showUserMembers}
              onChangeMemberInput={onChangeMemberInput}
              onKeyDownAddMembers={onKeyDownAddMembers}
              onClickMemberSuggestion={onClickMemberSuggestion}
              handleLostFocus={handleLostFocus}
              handleOnFocus={handleOnFocus}
              usersFromProjectAndDepartment={UsersFromProjectAndDepartment}
            />
          </Form.Group>
        ))}
      </Container>
    </div>
  );
};

TaskAssignMembersMultiOwner.propTypes = {
  assignedMembers: PropTypes.arrayOf(PropTypes.shape({
    Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    Name: PropTypes.string.isRequired,
    IsGroup: PropTypes.bool,
    IsProjectMember: PropTypes.bool
  })).isRequired,
  assignedOwner: PropTypes.oneOfType([
    PropTypes.shape({
      Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      Name: PropTypes.string.isRequired
    }),
    PropTypes.arrayOf(PropTypes.shape({
      Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      Name: PropTypes.string.isRequired
    }))
  ]),
  filteredAssignedMembers: PropTypes.arrayOf(PropTypes.string).isRequired,
  addMembersInForm: PropTypes.func.isRequired,
  removeMembersInForm: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  permissionTaskMembers: PropTypes.arrayOf(PropTypes.shape({
    Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    canEdit: PropTypes.bool,
    canView: PropTypes.bool,
    canApprove: PropTypes.bool,
    isOwner: PropTypes.bool
  })),
  ownerGroup: PropTypes.shape({
    GroupMembers: PropTypes.array,
    Members: PropTypes.array
  }),
  CanChangeApprover: PropTypes.bool,
  CanChangeEditor: PropTypes.bool,
  CanChangeViewer: PropTypes.bool,
  CanChangeOwner: PropTypes.bool
};

TaskAssignMembersMultiOwner.defaultProps = {
  permissionTaskMembers: [],
  ownerGroup: null,
  isDisabled: false,
  CanChangeApprover: false,
  CanChangeEditor: false,
  CanChangeViewer: false,
  CanChangeOwner: false
};

export default TaskAssignMembersMultiOwner;
